export enum MyDSpaceConfigurationValueType {
  Workspace = 'workspace',
  SupervisedItems = 'supervisedWorkspace',
  OtherWorkspace = 'otherworkspace',
  Workflow = 'workflow'
}
